import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAutotaskPodDataByContactId } from 'services/pod';
import { IPodData } from 'services/pod/types';
import { convertSimplifiedToPodData } from 'store/pod/helpers';

interface IProps {
  psaId: number;
  contactId: number;
}

export const ThunkGetAutotaskPodDataByContactId = createAsyncThunk<IPodData, IProps>(
  'pod/getAutotaskPodDataByContactId',
  async ({ psaId, contactId }) =>
    getAutotaskPodDataByContactId(psaId, contactId)
      .then(res => res.data)
      .then(data => convertSimplifiedToPodData(data)),
);
